import { Game } from '@core/models/games/Game';

export default function gameComparator(first: Game, second: Game): number {
    if (first.order === second.order) {
        if (!first.externalId || !second.externalId) {
            return first.order - second.order;
        }
        if (first.externalId >= 10000 && second.externalId < 10000) {
            return -1;
        }
        if (first.externalId < 10000 && second.externalId >= 10000) {
            return 1;
        }
        return first.externalId - second.externalId;
    }
    return first.order - second.order;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/sortComparators/gameComparator.ts